import React, { FC } from "react";
import { Input, Button, Modal, Row, Col, Form } from "antd";

import { SocketTopics } from "../../constants/enums";
import { wrapRequestPayload } from "../../helpers/request/RequestPayload";

import { getCreatePagePublishTopic } from "hooks/MQTTConstants";

import { UserRoles } from "utils/appUtil";
import { pushNotification } from "utils/notifications";

const CreateNewPageModal: FC<{
  isModalVisible?: CreateNewPageModelObj;
  setIsModalVisible?: (isModalVisible: CreateNewPageModelObj) => void;
  onClose?: () => void;
  onCreated?: () => void;
  socket?: ISocket;
  currentLocation?: CurrentLocation;
  page_group?: any;
}> = ({
  onClose,
  onCreated,
  socket,
  currentLocation,
  isModalVisible,
  setIsModalVisible,
}) => {
  const [createPageForm] = Form.useForm();

  const handleCancel = () => {
    const prevObj: CreateNewPageModelObj = { ...isModalVisible };
    setIsModalVisible({
      ...prevObj,
      visible: false,
    });
    onClose && onClose();
  };

  const createPage = (
    title: string,
    members: any,
    groups: any,
    location?: CurrentLocation
  ) => {
    const changes = [
      {
        op: "replace",
        path: "/persistent/static/metadata/title",
        value: title,
      },
      {
        op: "replace",
        path: "/persistent/static/metadata/type",
        value: isModalVisible.type,
      },
      {
        op: "replace",
        path: "/persistent/static/metadata/createdAt",
        value: new Date().getTime(),
      },
      {
        op: "add",
        path: "/nonpersistent/dynamic/metadata/lastSent/members/updatedAt",
        value: new Date().getTime(),
      },
      {
        op: "replace",
        path: `/persistent/static/metadata/members/users`,
        value: members,
      },
      {
        op: "replace",
        path: `/persistent/static/metadata/members/orgGroups`,
        value: groups,
      },
      {
        op: "add",
        path: "/partitions",
        value: [`org:${localStorage.getItem("selectedOrg") || "cudb-live"}`],
      },
    ];
    if (location) {
      changes.push({
        op: "replace",
        path: `/persistent/static/live/location`,
        value: {
          coordinates: {
            lat: location.latitude,
            long: location.longitude,
          },
        },
      });
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreatePagePublishTopic(),
      wrapRequestPayload({ changes }),
      (data) => {
        if (!data.status) {
          pushNotification(data.message, "error");
        } else {
          pushNotification("Page has been created successfully", "success");
          const prevObj: CreateNewPageModelObj = { ...isModalVisible };
          setIsModalVisible({
            ...prevObj,
            visible: false,
          });
          onCreated && onCreated();
          onClose && onClose();
        }
      }
    );
  };

  const handleOk = () => {
    let title = createPageForm.getFieldValue("title");
    let members: any = {};

    members[localStorage.getItem("RID")] = {
      role: UserRoles.Edit,
    };

    if (socket.client && title) {
      if (currentLocation) {
        createPage(title, members, {}, currentLocation);
      } else {
        createPage(title, members, {});
      }
    }
  };

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible.visible}
        onOk={() => {}}
        onCancel={handleCancel}
        width="520px"
        className="beam-modal scrollable max-height-fix"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <div>
          <Form
            className="auth-form"
            name="login-form"
            id="login-form"
            layout="vertical"
            form={createPageForm}
            requiredMark={false}
          >
            <Row className="d-flex mt-1 mb-4">
              <Col>
                <h3>Create page</h3>
              </Col>
            </Row>
            <Row className="">
              <Col span={24}>
                <Form.Item
                  name="title"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <Input type="text" placeholder="Page title" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <Row className="action-grp sticky-footer">
          <Col span={14} className="pr-2">
            <Form.Item>
              <Button
                onClick={handleOk}
                className="beam-btn green-btn cover w-full"
                htmlType="submit"
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default CreateNewPageModal;
